import type { SupportTicket, SupportTicketMessage } from "../types";

interface MessageViewer {
  _id?: string;
  email?: string;
}

/** authorId populate edilmişse nesne, edilmemişse düz string döner */
const extractAuthorId = (
  authorId: SupportTicketMessage["authorId"],
): string | undefined => {
  if (!authorId) return undefined;
  return typeof authorId === "string" ? authorId : authorId._id;
};

/**
 * Mesajın konuşmanın hangi tarafına yerleşeceğini belirler.
 *
 * Hizalamayı `isFromSupport` ile yapmak yanıltıcı: backend admin rolündeki
 * kullanıcının cevaplarını destek adına işaretlediği için, kendi talebine
 * bakan bir admin kendi mesajlarını karşı tarafta görürdü. Bu yüzden önce
 * kimlik karşılaştırılır; misafirlerde (magic link) rol bilgisine düşülür.
 */
export const isOwnTicketMessage = (
  message: SupportTicketMessage,
  viewer: MessageViewer | null | undefined,
): boolean => {
  if (!viewer) return !message.isFromSupport;

  const authorId = extractAuthorId(message.authorId);
  if (authorId && viewer._id) return authorId === viewer._id;

  if (message.authorEmail && viewer.email) {
    return message.authorEmail.toLowerCase() === viewer.email.toLowerCase();
  }

  return !message.isFromSupport;
};

/**
 * Ticket'ın, ekrana bakan kullanıcı tarafından açılıp açılmadığını belirler.
 *
 * Admin rolündeki kullanıcılar listede herkesin ticket'ını gördüğü için
 * rol bilgisine ihtiyaç duymadan kimlik karşılaştırması yapılır: userId
 * eşleşmezse (fallback: e-posta) ticket başka bir kullanıcıya aittir ve
 * arayüz talep sahibini ayrıca gösterir.
 */
export const isOwnTicket = (
  ticket: Pick<SupportTicket, "userId" | "email">,
  viewer: MessageViewer | null | undefined,
): boolean => {
  if (!viewer) return true;

  if (ticket.userId && viewer._id) return ticket.userId === viewer._id;

  if (ticket.email && viewer.email) {
    return ticket.email.toLowerCase() === viewer.email.toLowerCase();
  }

  return true;
};
